// src/pages/common/Dashboard.jsx
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSpinner } from 'react-icons/fa';
import useAuthStore from '../../store/authStore';
import Swal from 'sweetalert2';

// Hooks personalizados
import { useDashboardData } from '../../hooks/useDashboardData';
// import { useCampaignIdeaGenerator } from '../../hooks/useCampaignIdeaGenerator';
import { useBusinessAnalyzer } from '../../hooks/useBusinessAnalyzer';

// Componentes del Dashboard
import DashboardHeader from '../../components/dashboards/DashboardHeader';
import PriorityObjectiveCard from '../../components/dashboards/PriorityObjectiveCard';
// import AIInsightsCard from '../../components/dashboards/AIInsightsCard';
import BusinessMetricsGrid from '../../components/dashboards/BusinessMetricsGrid';
import QuickActionsGrid from '../../components/dashboards/QuickActionsGrid';
import RecommendedActionsCard from '../../components/dashboards/RecommendedActionsCard';
// import KeyDateCard from '../../components/dashboards/KeyDateCard';
// import ActiveStrategyCard from '../../components/dashboards/ActiveStrategyCard';
// import LastStrategyCard from '../../components/dashboards/LastStrategyCard';
import BuyerPersonaCard from '../../components/buyerPersona/BuyerPersonaCard';
// import CampaignStatsWidget from '../../components/dashboards/CampaignStatsWidget';
import { BirthdayCalendar } from '../../components/dashboards';

// Modales
import PredefinedCampaignModal from '../../components/gameLoyalty/PredefinedCampaignModal';
import StrategyReviewModal from '../../components/modals/StrategyReviewModal';
// import IntelligentCampaignModal from '../../components/modals/IntelligentCampaignModal';

// Helpers
import {
  strategyManagement,
  agentsUtils
} from '../../helpers/agentsHelper';

import InsightsCard from '../../components/dashboards/InsightsCard';

const Dashboard = () => {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const userId = user.userId;

  // Estados para modales
  const [showCampaignModal, setShowCampaignModal] = useState(false);
  // const [showIntelligentCampaignModal, setShowIntelligentCampaignModal] = useState(false);
  const [strategyForReview, setStrategyForReview] = useState(null);
  const [showStrategyModal, setShowStrategyModal] = useState(false);
  // const [selectedObjectiveFechaClave, setSelectedObjectiveFechaClave] = useState('');
  // const [selectedMarcaId, setSelectedMarcaId] = useState('');
  const [campaignLoading] = useState(false);

  // Hooks personalizados
  const {
    marcasStats,
    loading,
    // aiInsights,
    // ultimaEstrategia,
    // fechaClaveProxima,
    priorityObjective,
    dashboardMetrics
  } = useDashboardData(userId);

  // const {
  //   generatingIdea,
  //   ideaGenerationCooldown,
  //   cooldownTimeRemaining,
  //   generateCampaignIdea
  // } = useCampaignIdeaGenerator(userId, marcasStats);

  const { analyzingBusiness, analyzeBusiness } = useBusinessAnalyzer(userId, navigate);

  // Handlers
  // const openIntelligentCampaignModal = () => setShowIntelligentCampaignModal(true);
  // const closeIntelligentCampaignModal = () => setShowIntelligentCampaignModal(false);

  // const handleGenerateIdeaSuccess = () => {
  //   openIntelligentCampaignModal();
  // };

  // Handler para la nueva funcionalidad de cadena de agentes de marketing
  const handleOpenMarketingChain = () => {
    navigate('/marketing-chain');
  };

  const handleNavigateToAnalytics = () => {
    navigate('/statistics/dashboard');
  };

  const handleNavigateToMarketingHistory = () => {
    navigate('/marketing-chain/history');
  };

  const handleNavigateToSocialContent = () => {
    navigate('/social-content');
  };


  /*
  async function crearCampaniaConFechaClave(fechaClaveId) {
    if (!selectedObjectiveFechaClave) {
      Swal.fire({
        title: 'Falta objetivo',
        text: 'Selecciona el objetivo que deseas alcanzar',
        icon: 'warning'
      });
      return;
    }
    const marcaToUse = multipleMarcas ? selectedMarcaId : marcasStats[0]._id;
    // Si hay campaña pendiente se abre el modal de revisión y se evita crear una nueva
    const pendingUsed = await checkPendingCampaign(marcaToUse);
    if (pendingUsed) return;
    try {
      setCampaignLoading(true);

      // Usar el nuevo endpoint optimizado con contexto
      const context = agentsUtils.formatContext({
        tipoNegocio: marcasStats.find(m => m._id === marcaToUse)?.tipo || 'Comercio',
        pais: 'España',
        presupuesto: '5000€',
        tiempoLimite: '3 meses'
      });

      const result = await orchestrationOptimized.runFullChain(
        userId,
        selectedObjectiveFechaClave,
        fechaClaveId,
        context
      );

      if (result.ok) {
        setStrategyForReview(result);
        setShowStrategyModal(true);
      } else {
        Swal.fire({
          title: 'Error',
          text: result.message,
          icon: 'error'
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        title: 'Error',
        text: 'No se pudo crear la campaña.',
        icon: 'error'
      });
    } finally {
      setCampaignLoading(false);
    }
  }
  */

  async function handleAcceptStrategy() {
    const strategyId = agentsUtils.getStrategyId(strategyForReview);
    if (!strategyId) {
      console.error('No se encontró un strategyId válido');
      return;
    }
    try {
      // Actualiza el estado de la estrategia a "aprobada"
      const updated = await strategyManagement.updateStrategyStatus(strategyId, 'aprobada');
      const finalResult = await strategyManagement.createInSystem(userId, updated);
      if (finalResult.message) {
        Swal.fire({ title: 'Campaña creada', text: finalResult.message, icon: 'success' });
      }
      setShowStrategyModal(false);
      setStrategyForReview(null);
    } catch (error) {
      console.error(error);
      Swal.fire({ title: 'Error', text: 'No se pudo crear la campaña.', icon: 'error' });
    }
  }

  async function handleRejectStrategy() {
    const strategyId = agentsUtils.getStrategyId(strategyForReview);
    if (!strategyId) {
      console.error('No se encontró un strategyId válido');
      return;
    }
    try {
      await strategyManagement.updateStrategyStatus(strategyId, 'rechazada');
      Swal.fire({ title: 'Campaña rechazada', text: 'La campaña pendiente ha sido rechazada.', icon: 'info' });
      setShowStrategyModal(false);
      setStrategyForReview(null);
    } catch (error) {
      console.error(error);
      Swal.fire({ title: 'Error', text: 'No se pudo rechazar la campaña.', icon: 'error' });
    }
  }

  async function handleCancelStrategy() {
    setShowStrategyModal(false);
    setStrategyForReview(null);
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="text-center">
          <FaSpinner className="animate-spin text-blue-500 text-4xl mx-auto mb-4" />
          <p className="text-gray-600">Cargando tu dashboard...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-full mx-auto px-2 sm:px-4 py-4 sm:py-6 overflow-x-hidden">

        {/* Header Principal */}
        <DashboardHeader />

        {/* Objetivo Principal - Horizontal en la parte alta */}
        <div className="mb-4 sm:mb-8">
          <PriorityObjectiveCard
            userId={userId}
            onActionClick={handleOpenMarketingChain}
          />
        </div>

        {/* Primera Fila - Métricas e Insights/Recomendaciones */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-6 mb-4 sm:mb-8">

          {/* Columna 1 - Métricas del Mes y Acciones Rápidas */}
          <div className="lg:col-span-4 w-full flex flex-col space-y-4 sm:space-y-6">
            {/* Métricas del Mes */}
            <div className="bg-white rounded-lg shadow-sm p-3 flex-[2]">
              <div className="mb-3">
                <h3 className="text-lg font-semibold text-gray-900">Métricas del Mes</h3>
              </div>
              <BusinessMetricsGrid marcasStats={marcasStats} dashboardMetrics={dashboardMetrics} />
            </div>
            
            {/* Acciones Rápidas */}
            <div className="flex-[1]">
              <QuickActionsGrid
                onAnalyzeBusiness={analyzeBusiness}
                onNavigateToAnalytics={handleNavigateToAnalytics}
                onNavigateToMarketingHistory={handleNavigateToMarketingHistory}
                onNavigateToSocialContent={handleNavigateToSocialContent}
                analyzingBusiness={analyzingBusiness}
                generatingIdea={false}
                ideaGenerationCooldown={false}
                cooldownTimeRemaining={0}
              />
            </div>
          </div>

          {/* Columna 2 - Insights y Recomendaciones */}
          <div className="lg:col-span-8 w-full">
            <div className="space-y-4 sm:space-y-6 h-full">

              {/* Insights */}
              <div className="bg-white rounded-lg shadow-sm p-4 flex-1">
                <div className="mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">Insights</h3>
                </div>
                <InsightsCard />
              </div>

              {/* Recomendación Semanal */}
              <div className="bg-white rounded-lg shadow-sm p-4 flex-1">
                <div className="mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">Recomendación Semanal</h3>
                </div>
                <RecommendedActionsCard />
              </div>

            </div>
          </div>

        </div>

        {/* Tercera Fila - Buyer Persona y Calendario */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 sm:gap-6 mb-4 sm:mb-8">

          {/* Columna 1 - Buyer Persona */}
          <div className="lg:col-span-6 w-full">
            <BuyerPersonaCard />
          </div>

          {/* Columna 2 - Calendario de Cumpleaños */}
          <div className="lg:col-span-6 w-full">
            <BirthdayCalendar />
          </div>

        </div>



        {/* Última Estrategia Detallada - Comentado temporalmente */}
        {/* <LastStrategyCard userId={userId} /> */}

      </div>

      {/* Modales */}
      {showCampaignModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-end sm:items-center justify-center min-h-screen p-0 sm:p-4">
            <PredefinedCampaignModal
              onClose={() => setShowCampaignModal(false)}
              onCampaignCreated={() => {
                window.location.reload();
              }}
              userMarcaId={marcasStats.length === 1 ? marcasStats[0]._id : ''}
            />
          </div>
        </div>
      )}
      {/* Modal de Campaña Inteligente - Comentado temporalmente */}
      {/* {showIntelligentCampaignModal && (
        <IntelligentCampaignModal
          isOpen={showIntelligentCampaignModal}
          onClose={closeIntelligentCampaignModal}
          marcas={marcasStats}
          userId={userId}
          onCampaignCreated={() => {
            closeIntelligentCampaignModal();
            refetchData();
          }}
        />
      )} */}
      <StrategyReviewModal
        isOpen={showStrategyModal}
        strategy={strategyForReview || { descripcion: '' }}
        loading={campaignLoading}
        onAccept={handleAcceptStrategy}
        onReject={handleRejectStrategy}
        onCancel={handleCancelStrategy}
        isPending={strategyForReview && strategyForReview?.estado === 'pendiente'}
      />
    </div>
  );
};

export default Dashboard;
